import { render } from "./Baner.vue?vue&type=template&id=02867455&scoped=true"
import script from "./Baner.vue?vue&type=script&lang=js"
export * from "./Baner.vue?vue&type=script&lang=js"

import "./Baner.vue?vue&type=style&index=0&id=02867455&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-02867455"

export default script